import { MuteState, Settings, UpdateSettingsInput } from '../../settings.js';
export const settingsRoutes = {
    get: { method: 'GET', path: '/me/settings', response: Settings },
    update: {
        method: 'PATCH',
        path: '/me/settings',
        body: UpdateSettingsInput,
        response: Settings,
    },
    mute: { method: 'POST', path: '/users/:userId/mute', response: MuteState },
    unmute: { method: 'DELETE', path: '/users/:userId/mute', response: MuteState },
};
//# sourceMappingURL=routes.js.map